export default __webpack_public_path__ + "static/media/ios-image.84305888.svg";